// src/components/PaymentResults.js

import React from "react";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const PaymentResults = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Goes back to the previous route
  };

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
      {/* Close Button */}
      <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 1000,
          backgroundColor: "white",
          boxShadow: 3,
          borderRadius: 1,
          padding: "4px 8px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleGoBack}
          size="small"
        >
          Back
        </Button>
      </Box>

      {/* Iframe */}
      <iframe
        src="https://zapdrivingschool.co.ke/payment_results "
        title="Payment Results"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    </Box>
  );
};

export default PaymentResults;
